// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fm .upload-picture-cover[data-v-4c288430] {\n  padding-bottom: 0px !important;\n}", ""]);
// Exports
module.exports = exports;
